'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContactUs = function (_React$Component) {
  (0, _inherits3.default)(ContactUs, _React$Component);

  function ContactUs() {
    (0, _classCallCheck3.default)(this, ContactUs);
    return (0, _possibleConstructorReturn3.default)(this, (ContactUs.__proto__ || (0, _getPrototypeOf2.default)(ContactUs)).call(this));
  }

  (0, _createClass3.default)(ContactUs, [{
    key: 'handleCancelClick',
    value: function handleCancelClick(e) {
      e.preventDefault();
      this.props.onCloseNo('Cancelled');
    }
  }, {
    key: 'forceClose',
    value: function forceClose(reason) {
      this.props.onCloseNo(reason);
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./ContactUs.scss');

      return _react2.default.createElement(
        _components.ContactBox,
        { title: 'Looking for a customized plan?', message: 'We would be happy to tailor a plan that suits your needs. Leave us a note and we will get back to you soon.' },
        _react2.default.createElement(
          'div',
          { className: styles['ContactForm__fields'] },
          _react2.default.createElement(_components.TextInput, { simpleError: true, ref: 'name', title: 'Name', className: styles['ContactForm__input--name'] }),
          _react2.default.createElement(_components.TextInput, { simpleError: true, title: 'Email', className: styles['ContactForm__input--email'] })
        ),
        _react2.default.createElement(
          'div',
          { className: styles['ContactForm__fields'] },
          _react2.default.createElement(_components.TextInput, { simpleError: true, title: 'Message', className: styles['ContactForm__input--message'] })
        ),
        _react2.default.createElement(
          'div',
          { className: styles['ContactForm__buttons'] },
          _react2.default.createElement(_components.Button, { className: styles['ContactForm__button'], label: 'Cancel', onClick: this.handleCancelClick.bind(this) }),
          _react2.default.createElement(_components.Button, { primary: true, alternative: true, className: styles['ContactForm__button'], label: 'Send Message' })
        )
      );
    }
  }]);
  return ContactUs;
}(_react2.default.Component);

exports.default = ContactUs;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ContactUs/ContactUs.jsx
// module id = 2728
// module chunks = 0